"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/web.dom.iterable");require("core-js/modules/es6.number.constructor");


















var _groupSkill = _interopRequireDefault(require("./groupSkill"));
var _groupSkillParams = _interopRequireDefault(require("./groupSkillParams")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { name: 'GroupSkillLayout', components: { GroupSkill: _groupSkill.default, GroupSkillParams: _groupSkillParams.default }, props: { taskId: { type: Number }, flowId: { type: Number }, taskSkill: {} }, data: function data() {return { params: [] };

  },
  mounted: function mounted() {
    var self = this;
    console.log('l->task:', self.taskSkill);
    self.handleGetSkillData(self.taskSkill);
  },
  methods: {
    handleGetSkillData: function handleGetSkillData(taskSkill) {
      /**
                                                                console.log('getSkill->' + taskId + ',' + flowId)
                                                                const self = this
                                                                if (self.$refs['groupSkill']) {
                                                                  console.log('getSkillSkill')
                                                                  self.$refs.groupSkill.handleGetData(taskId, flowId)
                                                                }*/
      console.log('taskSkill', taskSkill);
      var self = this;
      if (self.$refs['groupSkill']) {
        self.$refs.groupSkill.handleGetData(taskSkill);
      }
    },
    handleGetParams: function handleGetParams(params) {
      this.handleGetModParams();
      this.$refs.skillParams.handleGetParams(params);
    },
    handleGetModParams: function handleGetModParams() {
      var modelResult = this.$refs.skillParams.handleGetResult();
      this.$refs.groupSkill.handleSetMod(modelResult);
    },
    handleGetLayoutResult: function handleGetLayoutResult() {
      var self = this;
      var result = {};
      if (self.$refs.groupSkill) {
        var skillResult = self.$refs.groupSkill.handleGetResult();
        console.log('skillResult', skillResult);
        result.skillResult = skillResult;
      }
      if (self.$refs.skillParams) {
        var paramResult = self.$refs.skillParams.handleGetResult();
        console.log('paramsResult', paramResult);
        result.paramResult = paramResult;
        if (paramResult && result.skillResult && paramResult.paramList.length > 0) {
          result.skillResult.skills.forEach(function (skill) {
            if (skill.skillId === paramResult.skillId) {
              skill.paramList = paramResult.paramList;
            }
          });
        }
      } else {
        console.log('no param result');
      }

      return result;
    },
    onSubmit: function onSubmit() {
      var self = this;
      var result = self.handleGetLayoutResult();
      console.log('taskSkill', self.taskSkill);
      var postData = {
        'isStay': parseInt(result.skillResult.isStay),
        'orderNum': self.taskSkill.orderNum,
        'skills': result.skillResult.skills,
        'deleteSkillIds': result.skillResult.deleteSkillIds,
        'stayTime': result.skillResult.stayTime === '' ? '00:00:00' : result.skillResult.stayTime };

      console.log('postData', postData);
      var path = '/api/temi/robot/task/' + self.taskSkill.taskId + '/flow/' + self.taskSkill.flowId + '/taskSkill/groups';
      self.postData(path, postData, function (res) {
        self.$message({
          message: '添加成功!',
          type: 'success' });

      });
    },
    handleClearParams: function handleClearParams() {
      var self = this;
      console.log('lll-clear');
      if (self.$refs.skillParams) {
        console.log('l-clear');
        self.$refs.skillParams.handleClearParams();
      }
    } } };exports.default = _default;